import * as React from "react";
import { HorizontalCardsPanel, IHorizontalCardsPanelProps } from "../../../components/panels/HorizontalCardsPanel";
import { IContentfulRichTextResponse } from "../../../types/IContentfulRichText";
import { IModule } from "../types";

export type GetHorizontalCardsPanelProps = IModule<Omit<IHorizontalCardsPanelProps, "title"> & {
  titleRichText: IContentfulRichTextResponse;
}>

export const getHorizontalCardsPanel: React.FC<GetHorizontalCardsPanelProps> = ({
  id, titleRichText, subtitle, isBetterV2, cards, variant,
}) => (
  <HorizontalCardsPanel
    key={id}
    isBetterV2={isBetterV2}
    title={titleRichText}
    subtitle={subtitle}
    cards={cards}
    variant={variant}
  />
);
